import { IAccessScope, ITenant } from '../../../../reducers/Reducers.interfaces'
import { IActionCreatorAsync } from '../../../../core/actions/Actions.interfaces'

export enum EditingTypes {
    SSO_SAML = 'sso-saml',
    OIDC = 'oidc',
    TFA = 'tfa',
    PASSWORD_ONLY = 'password-only',
}

export interface SignInMethodsProps {
    accessScope?: IAccessScope
    account: ITenant
    canEdit : boolean
}

export interface SignInMfaDispatchProps {
    enableMfa: IActionCreatorAsync
    fetchTenantById: IActionCreatorAsync
    editStandardSignIn: IActionCreatorAsync
    getAccountSignIn: IActionCreatorAsync
    setAccount: (any) => void
    updateClientAuthCertLogin: IActionCreatorAsync
}

export type ExtendedSignInMethodsProps = SignInMethodsProps & SignInMfaDispatchProps
